import { render, staticRenderFns } from "./NewProjectList.vue?vue&type=template&id=a41cd362"
import script from "./NewProjectList.vue?vue&type=script&lang=js"
export * from "./NewProjectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports